var map = {
	"./25 Jahre 1.jpg": 9370,
	"./25 Jahre 3.jpg": 7818,
	"./25 Jahre 4.jpg": 7307,
	"./25Jahre 5.jpg": 445,
	"./25Jahre7.jpg": 2549,
	"./CafeScheffler2008-768x511.jpg": 5173,
	"./Chor-2009b-60-768x440.jpg": 9663,
	"./Chor-2019-01-20.jpg": 5302,
	"./Chor2008-768x511.jpg": 5961,
	"./Konzert2009-60.jpg": 722,
	"./Vorstand.jpg": 7035,
	"./chor-3-20-1-768x576.jpg": 3401,
	"./heide2012-768x540.jpg": 6017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5620;